import styled from 'styled-components';

export const HeaderButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 12px;
`;
